import {
  isLegacyType,
  LegacySingleType,
  Type,
} from '../../../../client/components/TypeDetails/typeParser';
import { isPrimitiveType } from '../../../../client/components/TypeDetails/NestedTable/utils';
import { getObjectByPath } from '../../utils';
import { pathToTreeKeys } from '../../deleteMembers';

const updateCallbackParamTypeIfNeeded = (
  type: LegacySingleType | Type,
  originalCategoryObj,
  newCategoryObj,
) => {
  const shouldUpdateCallbackType = (): boolean => {
    if (isLegacyType(type)) {
      return !isPrimitiveType(type) && typeof type === 'string';
    } else {
      return !!type.referenceType;
    }
  };

  if (shouldUpdateCallbackType()) {
    updateCallbackType(
      isLegacyType(type)
        ? (type as string) // if the type is in legacy schema, then typeof type === string was checked earlier
        : type.referenceType,
      originalCategoryObj,
      newCategoryObj,
    );
  }
};

const updateCallbackType = (
  type: string,
  originalCategoryNode: any,
  newCategoryNode: any,
) => {
  const path = type.split('.').slice(1).join('.');
  const nodeToTakeCallbackFrom = getObjectByPath(
    originalCategoryNode,
    pathToTreeKeys(path),
  );
  const nodeToMoveCallbackTo = getObjectByPath(
    newCategoryNode,
    pathToTreeKeys(path),
  );
  if (nodeToTakeCallbackFrom && nodeToMoveCallbackTo) {
    const callbackToAdd = nodeToTakeCallbackFrom.data?.callbacks?.find(
      (cb) => cb.name === path.split('.').pop(),
    );
    const shouldAddCallback =
      callbackToAdd &&
      !nodeToMoveCallbackTo.data?.callbacks?.some(
        (cb) => cb.name === callbackToAdd.name,
      );
    if (shouldAddCallback) {
      if (!nodeToMoveCallbackTo.data.callbacks) {
        nodeToMoveCallbackTo.data.callbacks = [];
      }
      nodeToMoveCallbackTo.data.callbacks.push(callbackToAdd);
    }
  }
};

export const updateCallbacks = (
  newCategoryObj: any,
  originalCategoryObj: any,
) => (node: any) => {
  const membersToUpdate = ['operations', 'clientEvents'];
  membersToUpdate.forEach((membersKey) => {
    if (node && node[membersKey]) {
      node[membersKey].forEach((member) => {
        member.params.forEach((param) => {
          if (Array.isArray(param.type)) {
            param.type.forEach((singleType) => {
              updateCallbackParamTypeIfNeeded(
                singleType,
                originalCategoryObj,
                newCategoryObj,
              );
            });
          } else {
            updateCallbackParamTypeIfNeeded(
              param.type,
              originalCategoryObj,
              newCategoryObj,
            );
          }
        });
      });
    }
  });
};
